import type { FlightCardData } from '@massilia/queries'

import { Button, FullScreenOverlay } from '@massilia/ui'
import { useEffect, useState } from 'react'

import { useFiltersState } from './filters-state-context'
import { FlightFilters } from './flight-filters'

interface FiltersModalProps {
  isOpen: boolean
  offers: FlightCardData[]
  onClose: () => void
  shouldRefetchWithLuggage?: boolean
}

export function FiltersModal({ isOpen, offers, onClose, shouldRefetchWithLuggage }: FiltersModalProps) {
  const { filters, setFilters } = useFiltersState()
  const [localFilters, setLocalFilters] = useState(filters)

  useEffect(() => {
    if (isOpen) {
      setLocalFilters(filters)
    }
  }, [isOpen, filters])

  return (
    <FullScreenOverlay
      footer={
        <Button
          className="bg-brand-600 hover:bg-brand-700 w-full"
          onClick={() => {
            setFilters(localFilters)
            onClose()
          }}
        >
          Appliquer
        </Button>
      }
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      open={isOpen}
      title="Filtres"
    >
      <div className="px-4 py-4">
        <FlightFilters offers={offers} shouldRefetchWithLuggage={shouldRefetchWithLuggage} />
      </div>
    </FullScreenOverlay>
  )
}
